export default function (language?: string): SupportedLocale {
  const locale = language?.toLowerCase() ?? 'de'
  if (!supportedLocaleOptions.includes(locale as SupportedLocale)) {
    defaultLogger.warn(`Unsupported locale: ${locale}, defaulting to 'de'`)
    return 'de'
  }

  return locale as SupportedLocale
}
